var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g({class:_vm.$style.input,attrs:{"type":_vm.type},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('update', $event.target.value)}}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }